const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/videos/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/videos/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type StatusFilter = "all" | "published" | "draft";